import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const AddToyDialog = ({ open, features, onClose, onSave }) => {
  const [name, setName] = useState("");
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [nameError, setNameError] = useState(false);
  const [featureError, setFeatureError] = useState(false);

  const handleNameChange = event => {
    setName(event.target.value);
  };

  const handleFeatureChange = event => {
    const feature = event.target.name;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedFeatures([...selectedFeatures, feature]);
    } else {
      setSelectedFeatures(selectedFeatures.filter(f => f !== feature));
    }
  };

  const handleSave = () => {
    if (name.trim() === "") {
      setNameError(true);
      return;
    }
    if (selectedFeatures.length === 0) {
      setFeatureError(true);
      return;
    }
    onSave(name, selectedFeatures);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="Name"
          label="Name"
          type="text"
          fullWidth
          value={name}
          onChange={handleNameChange}
          error={nameError}
          helperText={nameError && "Name cannot be empty, or existing"}
        />
        {features.map(feature => (
          <FormControlLabel
            key={feature}
            control={<Checkbox />}
            label={feature}
            name={feature}
            onChange={handleFeatureChange}
            style={{ color: featureError ? "red" : "inherit" }}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddToyDialog;
